/**
 * Lo que hay que devolver de un pago en efectivo: lo recibido menos lo que se paga en efectivo.
 * Negativo es que falta plata y positivo que sobra; `null` es que aún no han escrito cuánto
 * recibieron, que no es cero. Se redondea la diferencia, que es el billete que se entrega.
 */
export function vueltoDe(recibido: number | null, aPagarEnEfectivo: number): number | null {
  if (recibido === null) return null;
  return Math.round(recibido - aPagarEnEfectivo);
}
